// frontend/src/components/AboutSection.js
import React from 'react';
import './AboutSection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

// Importing icons for story sections
import { FaLeaf, FaHandsHelping, FaGlobeAsia } from 'react-icons/fa'; 

// ---> PASTE YOUR 3 CLOUDINARY LINKS HERE <---
const rootsImageUrl = "https://res.cloudinary.com/dit7yymcl/image/upload/v1772126527/Sroot_y3qmhg.webp";
const farmersImageUrl = "https://res.cloudinary.com/dit7yymcl/image/upload/v1772126511/abou_PM_wi1sxk.webp";
const journeyImageUrl = "https://res.cloudinary.com/dit7yymcl/image/upload/v1772126527/journeywebp_vagm46.webp";

const AboutSection = () => {
    // This hook will observe the main section to trigger the chapter animations
    const [sectionRef, isSectionVisible] = useScrollAnimation(0.1); 

    return (
        <section id="about-section" className="about-section" ref={sectionRef}>
            <h2 className="sectionn-title">About Green Pod</h2>

            {/* Container for the three main story sections */}
            <div className={`story-sections-wrapper ${isSectionVisible ? 'show' : ''}`}>

                {/* Section 1: Our Roots */}
                <div className="story-section transparent-card roots-section">
                    
                    {/* Image and Overlay as Background */}
                    <img src={rootsImageUrl} alt="Green Tea Plantation" className="card-bg-image" />
                    <div className="card-bg-overlay"></div>

                    {/* Icon - Inverted colors for contrast against image */}
                    <div className="section-icon-wrapper inverted-icon-wrapper">
                        <FaLeaf className="section-icon inverted-icon" />
                    </div>

                    {/* Content wrapped to sit above the image layer */}
                    <div className="card-content-relative">
                        <h3 className="section-chapter-title text-light">Our Roots</h3>
                        <p className="section-description text-light">
                           Our story begins in the spice rich hills of Kerala, where generations of farmers nurture the land with patience and pride.
                           Green Pod was created to honour their craft and bring those authentic flavours to UK homes.
                        </p>
                    </div>
                </div>

                {/* Section 2: Farmers */}
                <div className="story-section transparent-card craft-section">
                    
                    {/* Image and Overlay as Background */}
                    <img src={farmersImageUrl} alt="Farmers Hand in Basket" className="card-bg-image" />
                    <div className="card-bg-overlay"></div>

                    {/* Icon - Inverted colors for contrast against image */}
                    <div className="section-icon-wrapper inverted-icon-wrapper">
                        <FaHandsHelping className="section-icon inverted-icon" />
                    </div>

                    {/* Content wrapped to sit above the image layer */}
                    <div className="card-content-relative">
                        <h3 className="section-chapter-title text-light">Farmers</h3>
                        <p className="section-description text-light">
                           Many small-scale farmers in Kerala face market challenges and unstable pricing. By sourcing directly, we ensure fairer value and help sustain traditional spice cultivation.
                        </p>
                    </div>
                </div>

                {/* Section 3: The Journey */}
                <div className="story-section transparent-card journey-section">
                    
                    {/* Image and Overlay for Journey */}
                    <img src={journeyImageUrl} alt="Man holding spice packet in city" className="card-bg-image" />
                    <div className="card-bg-overlay"></div>

                    {/* Icon - Inverted colors for contrast against image */}
                    <div className="section-icon-wrapper inverted-icon-wrapper">
                        <FaGlobeAsia className="section-icon inverted-icon" />
                    </div>

                    {/* Content wrapped to sit above the image layer */}
                    <div className="card-content-relative">
                        <h3 className="section-chapter-title text-light">The Journey</h3>
                        <p className="section-description text-light">
                            From the lush green hills of Kerala to your hands, Green Pod carries the soul of our land in every spice. Every pack is a gift from the heart. Pure, honest, and full of heritage, so you can share the flavours, love, and care of Kerala with the world.
                        </p>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default AboutSection;